import { Component, inject, signal, computed } from '@angular/core';
import { RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

// Importar DBGrid desde shared
import {
  DbGridComponent,
  DbGridColumnComponent,
  GridRowSelectEvent,
  GridPageChangeEvent
} from '@components';
import { StoreService } from '@store/store.service';
import { LoginComponent } from './pages/login/login.component';
import { Helpers } from '@utils/helpers';
import { RouterHistoryService } from './app.routes.history';
import { ApiService } from '@services/index';
import { I18nService } from '@i18n/i18n.service';
import { Router } from '@angular/router';
// Actualiza las importaciones según el tipo:
// import { ApiService } from '@services/api.service';
// import { LoginResponseDto } from '@dtos/loginResponse.dto';
// import { CustomPipe } from '@pipes/custom.pipe';
// import { GlobalStore } from '@store/global';

const PUBLIC_ROUTES = ['/resetpassword', '/login'];

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  // Datos mock simples (40 usuarios)
  store = inject(StoreService);
  helper = inject(Helpers);
  history = inject(RouterHistoryService);
  apiService = inject(ApiService);
  i18n = inject(I18nService);
  router = inject(Router);
  

  private currentPath = signal(window.location.pathname);
  isPublicRoute = computed(() => PUBLIC_ROUTES.some(r => this.currentPath().startsWith(r)));

  constructor() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(event => {
      this.currentPath.set(event.urlAfterRedirects);
    });

    this.apiService.onErrorSession.subscribe(() => {
      this.store.global.logout();
      if (!this.isPublicRoute()) {
        this.helper.showToast(this.i18n.translate('errors.sessionExpired'), 'ERROR', 1500);
        this.router.navigateByUrl('/login');
      }
    });
  }
}
